import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PropTypes from "prop-types";

import RbButton from "components/RbButton";

import RbAlertContext from "./RbAlertContext";

export function RbAlertProvider(props) {
  const { children } = props;

  const [open, setOpen] = React.useState(false);

  const [executingButtonIndex, setExecutingButtonIndex] = React.useState(null);

  const [options, setOptions] = React.useState({});

  const closeAlert = React.useCallback(() => {
    setExecutingButtonIndex(null);
    setOpen(false);
  }, []);

  const openAlert = React.useCallback((_options) => {
    setOptions(_options);
    setOpen(true);
  }, []);

  const handleClickButton = React.useCallback((event, buttonConfig, index) => {
    const { onClick } = buttonConfig;
    if (onClick) {
      setExecutingButtonIndex(index);
      onClick(event);
    } else {
      setOpen(false);
    }
  }, []);

  const contextValue = React.useMemo(() => {
    return {
      openAlert,
      closeAlert,
    };
  }, [openAlert, closeAlert]);

  return (
    <RbAlertContext.Provider value={contextValue}>
      {children}
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        onClose={closeAlert}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">{options.title}</DialogTitle>
        {options.message && (
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {options.message}
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          {options.buttons?.map((buttonConfig, index) => (
            <RbButton
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              variant="contained"
              onClick={(event) => handleClickButton(event, buttonConfig, index)}
              color={buttonConfig.color}
              loading={Boolean(executingButtonIndex === index)}
              disabled={executingButtonIndex !== null}
            >
              {buttonConfig.text}
            </RbButton>
          ))}
        </DialogActions>
      </Dialog>
    </RbAlertContext.Provider>
  );
}

RbAlertProvider.propTypes = {
  /** Content of the component. */
  children: PropTypes.node,
};

RbAlertProvider.defaultProps = {
  children: null,
};

RbAlertProvider.displayName = "RbAlertProvider";

export default RbAlertProvider;
